<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="vx-col top-right" style="width:30px;" v-if="filter == true">
        <feather-icon icon="ChevronDownIcon" @click="hideFilter"></feather-icon>
      </div>

      <div class="vx-col top-right" style="width:30px;" v-else>
        <feather-icon icon="ChevronUpIcon" @click="showFilter"></feather-icon>
      </div>

      <transition name="fade">
        <div v-if="filter == true">
          <div class="borderAndMarginBottom">
            <div class="vx-row">
              <div class="vx-col md:w-1/12 w-full mt-2 marginLeft">
                <span><b>Tiêu đề:</b></span>
              </div>
              <div class="vx-col md:w-1/6 w-full mt-2">
                <vs-input
                  style="width:100%"
                  placeholder="Nhập nội dung tìm kiếm"
                  data-vv-valuedate-on="blur"
                  v-validate="'required'"
                  v-on:keydown.enter="loadData"
                  v-model="title"
                ></vs-input>
              </div>
              <div class="vx-col mt-2 marginLeft">
                <span><b>Từ:</b></span>
              </div>
              <div class="vx-col md:w-1/6 mt-2">
                <datepicker
                  v-model="dateRange.fromDate"
                  :format="formatDate"
                  @input="loadData"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                >
                </datepicker>
              </div>

              <div class="vx-col mt-2 marginLeft">
                <span><b>Đến:</b></span>
              </div>
              <div class="vx-col md:w-1/6 mt-2">
                <datepicker
                  date-vv-validate-on="input"
                  v-validate="'required'"
                  v-model="dateRange.toDate"
                  @input="loadData"
                  :format="formatDate"
                >
                </datepicker>
              </div>
              <div class="vx-col md:w-1/6 w-full mt-2 marginLeft">
                <span><b>Lọc tin:</b></span>
              </div>
              <div class="vx-col md:w-1/6 w-full mt-2">
                <vs-input
                  style="width:100%"
                  placeholder="Nhập nội dung tìm kiếm"
                  data-vv-valuedate-on="blur"
                  v-validate="'required'"
                  v-on:keydown.enter="loadData"
                  v-model="keyword"
                ></vs-input>
              </div>
            </div>
          </div>

          <div class="borderAndMarginBottom">
            <div class="vx-row">
              <div class="vx-col md:w-1/6 w-full mt-2">
                <span><b>Nguồn tin:</b></span>
              </div>
              <div class="vx-col md:w-1/3 w-full mt-">
                <v-select
                  v-on:input="loadData"
                  v-model="domains"
                  :clearable="true"
                  multiple
                  :options="listDomain"
                />
              </div>
              <div class="vx-col md:w-1/6 w-full mt-2">
                <span><b>Loại trừ nguồn tin:</b></span>
              </div>
              <div class="vx-col md:w-1/3 w-full mt-">
                <v-select
                  v-on:input="loadData"
                  v-model="exceptDomains"
                  :clearable="true"
                  multiple
                  :options="listDomain"
                />
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div style="height: auto;">
        <div class="borderAndMarginBottom">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 mt-2">
              <div>
                <div style="font-size:20px"><b>Có {{ totalElements }} nội dung</b></div>
                <span v-if="this.dateRange.fromDate">Từ <b>{{ this.formData.fromDate }} </b> </span>
                <span v-if="this.dateRange.toDate"
                      style="margin-right:5px">tới <b>{{ this.formData.toDate }}</b></span>
              </div>
            </div>
            <!-- <div class="vx-col md:w-1/2 mt-2">
                <div style = "float: right">
                  <feather-icon icon="DownloadIcon"></feather-icon>
                  <span> Xuất báo cáo</span>
                </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- GRID VIEW -->
      <template v-if="currentItemView =='item-grid-view'">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(item,index) in rowDatas" :key="index">
            <vx-card class="card">
              <feather-icon icon="GlobeIcon" class="p-2 shadow-drop rounded-lg d-theme-dark-bg facebook-icon"
                            v-if="item.beanType == 101"></feather-icon>
              <feather-icon icon="FacebookIcon" class="p-2 shadow-drop rounded-lg d-theme-dark-bg facebook-icon"
                            v-else></feather-icon>
              <span class="facebook-name"><b>{{ item.name }}</b></span>
              <div class="" style="margin-bottom:5px">
                <span style="font-size:10px">{{ item.datePublish }}</span>
              </div>
              <div class="vx-row comment cursor-pointer" @click="openDialog(item)">
                <div style="width:20%px;float:left; margin-right:10px;margin-bottom:10px" v-if="item.image !=null">
                  <img @error="imgError" data-v-3e4a5c2c="" :src="item.image" style="width:60px;height:60px">
                </div>
                <div style="width:20%px;float:left; margin-right:10px;margin-bottom:10px" v-else>
                  <img data-v-3e4a5c2c="" src="@/assets/images/logo/no_image.png" style="width:60px;height:60px">
                </div>
                <div id="inputText" style="width:78%; margin-left:1%; margin-top:1%" class="text">
                  <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">
                    {{ item.title }}</h6>
                  <p data-v-3e4a5c2c="" class="text-sm mb-4">
                  </p>
                  <p v-html="item.displayFullContent" data-v-3e4a5c2c="" class="item-description text-sm">
                  </p>

                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </template>

      <!-- LIST VIEW -->
      <template v-else>
        <div class="vx-col w-full" id="list-article">
          <vx-card class="card" v-for="(item,index) in rowDatas" :key="index" style="margin-bottom:10px">
            <div class="">
              <span style="font-size:10px">{{ item.datePublish }}</span>
            </div>
            <vs-button radius color="danger" @click="deletePost(item)" style="position:absolute; right: 10px;"
                       type="border" icon-pack="feather" icon="icon-trash" size="small" class="ml-3"></vs-button>
            <div class="vx-row comment cursor-pointer" @click="openDialog(item)">
              <div style="width:20%px;float:left; margin-right:10px;margin-bottom:10px" v-if="item.image !=null">
                <img onerror="this.onerror=null;this.src='@/assets/images/logo/no_image.png';" data-v-3e4a5c2c=""
                     :src="item.image" style="width:60px;height:60px">
              </div>
              <div style="width:20%px;float:left; margin-right:10px;margin-bottom:10px" v-else>
                <img data-v-3e4a5c2c="" src="@/assets/images/logo/no_image.png" style="width:60px;height:60px">
              </div>
              <div style="width:78%;" class="text">
                <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">
                  {{ item.domain + ' - ' + item.title }}</h6>
                <p data-v-3e4a5c2c="" class="text-sm mb-1">
                </p>
                <p data-v-3e4a5c2c="" class="item-description text-sm">{{ item.displayFullContent }}
                </p>

              </div>
            </div>
          </vx-card>
        </div>
      </template>

      <!-- POPUP VIEW -->
      <vs-popup class="holamundo " :title="dialogName" :active.sync="popupActive" id="full-article">
        <div class="vx-row w-full mt-2" style="height:80%">
          <div class="vx-col w-full">
            <span class="facebook-name"><b>{{ formData.domain }}</b></span>
            <div style="float:right">
              <vs-button radius color="danger" @click="deletePost(formData)" type="border" icon-pack="feather"
                         icon="icon-trash" size="small" class="ml-3"></vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row w-full mt-2">
          <div class="pl-4 pb-4">
            <span style="font-size:12px">{{ formData.datePublish }}</span>
          </div>
          <div class="pl-4 pb-4">
            <h4 data-v-3e4a5c2c="" class="item-name font-semibold mb-1">
              {{ formData.title }}</h4>
            <!--              <p data-v-3e4a5c2c="" class="text-sm" v-html="formData.displayFullContent"></p>-->
            <p data-v-3e4a5c2c="" class="py-4 font-semibold">{{ formData.description }}</p>

            <div v-for="(content, ind) in formData.fullContents" :key="ind">
              <img v-if="content.type === 'img'" :src="content.content" alt="" style="width: 100%; height: auto">
              <div v-if="content.type === 'text'" v-html="content.content" class="full-content"></div>
            </div>

          </div>
        </div>
        <div class="vx-col w-full mt-2" style="heigh:10%;border-top: 1px solid #ccc">
          <div class="link-post cursor-pointer">
            <a target="_blank" :href="formData.url">Tới bài viết gốc
              <feather-icon icon="ExternalLinkIcon" class="vertical-icon"></feather-icon>
            </a>
          </div>
        </div>
      </vs-popup>

      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage"
        :per-page="perPage"
        @change="onChangePage"
      ></vs-pagination>
      <!-- PAGINATION -->
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import NoImage from '@/assets/images/logo/no_image.png';

export default {
  components: {
    vSelect,
    Datepicker,
    NoImage
  },
  data() {
    return {
      to: '2019-04-23T10:26:00.996Z',
      from: '2018-04-23T10:26:00.996Z',
      panel: 'range',
      topic: null,
      optionalsTopic: [],
      userTopics: [],
      optionalsTopics: [
        {text: 'Tin tức', value: 0, checked: false},
        {text: 'Thể thao', value: 1, checked: false},
        {text: 'Website', value: 2, checked: false},
        {text: 'Blog', value: 3, checked: false}
      ],
      selectedItem: null,
      valueText: null,
      valueOldestPost: null,
      valueInteractive: null,
      radio: "SmileIcon",
      date: null,
      optionalsValue: "Tất cả chủ đề",
      checkbox: false,
      valueCheckbox: [],
      searchByIdAndName: null,
      currentItemView: 'item-list-view',
      checkBox: false,
      rowDatas: [],
      pageNumbers: null,
      pageSize: null,
      totalPages: 0,
      perPage: 10,
      maxPageNumbers: 6,
      currentPage: 1,
      gridApi: null,
      title: null,
      keyword: null,
      popupActive: false,

      dialogName: null,
      titleDialog: null,

      bookmark: true,
      star: false,
      domains: [],
      exceptDomains: [],
      valueRadio: null,

      filter: true,
      listDomain: [],
      responseDataTopic: [],
      topicName: null,

      dateRange: {
        fromDate: null,
        toDate: null
      },
      rangeDate: null,
      formData: {
        url: null,
        title: null,
        fullContents: null,
        datePublish: null,
        name: null,
        img: null,
        keyword: null,
        fromDate: null,
        toDate: null
      },
      userName: [],
      totalElements: null,
      beanType: null,

      // checkbox
      dataCheckBox: false,
      dataCheckBox2: false,
      dataCheckBox3: false,
      valueCheckBoxClassification: null,
      pooledNews: null,
      newsPostCheckBox: false,
      facePostCheckBox: false,
      faceCommentCheckBox: false,

      //Date
      dateNow: null,

    }
  },
  filters: {
    date(val) {
      return val ? moment(val).format('DD/MM/YYYY') : ''
    },
  },
  watch: {
    picker() {

    }
  },
  computed: {
    topicSelected: {
      get() {
        let object = this.optionalsTopic.find(el => el.value === this.topicName);
        if (!object) {
          return null
        }
        return {
          label: object.label,
          value: this.topicName
        }
      },
      set(object) {
        if (!object) {
          this.topicName = null;
        } else {
          this.topicName = object.value
        }
      }
    },
  },
  methods: {
    imgError(image) {
      image.target.src = NoImage;
    },
    highlight: function (text) {
      let inputText = document.getElementById("inputText");
      let innerHTML = inputText.innerHTML;
      let index = innerHTML.indexOf(text);
      if (index >= 0) {
        innerHTML = innerHTML.substring(0, index) + "<span class ='highlight'>" + innerHTML.substring(index, index + text.length) + "</span>" + innerHTML.substring(index + text.length);
        inputText.innerHTML = innerHTML;
      }
    },
    loadDomain: function () {
      this.$task.get('/newspaper/find-all').then((response) => {
        this.listDomain = Array.from(new Set(response.data.map(item => item.nameDomain)));
      }).catch((err) => {
      });
    },

    // Facebook-API
    loadData: function () {
      let payload = {
        pageNumber: this.pageNumbers,
        pageSize: 10,
        title: this.title,
        keyword: this.keyword,
        userDataElasticsearch: {},
        domains: this.domains,
        exceptDomains: this.exceptDomains,
        startDate: moment(this.dateRange.fromDate).set({hour: 0, minute: 0, second: 0}),
        endDate: moment(this.dateRange.toDate).set({hour: 23, minute: 59, second: 59})
      }
      this.$vs.loading();
      this.$processor.post('/search/find-data-news-detail', payload).then(response => {
        this.rowDatas = response.data.content.map(el => {
          if (el.publishDate) {
            el.datePublish = moment(el.publishDate).format("DD/MM/YYYY HH:mm");
          }
          if (el.fullContents) {
            for (let content of el.fullContents) {
              let str = content.content.replaceAll('\n', ' ').replaceAll('\r', ' ').trim(),
                index = el.fullContents.indexOf(content)
              if (str == el.description) el.fullContents.splice(index, 1)
            }
            el.displayFullContent = el.fullContents.filter(item => item.type == "text" && !item.content.includes('<') && !item.content.includes('>')).map((elements) => {
              return elements.content;
            }).join("\n");
          }
          if (el.attachmentUrls.length > 0) {
            let attachmentUrl = el.attachmentUrls[0];
            el.image = attachmentUrl.url;
          }
          return el;
        });
        this.totalPages = parseInt(response.data.totalPages, 10);
        this.totalElements = response.data.totalElements;
        this.pageNumbers = response.data.pageable.pageNumber;
        this.$vs.loading.close();
      }).catch(() => {
        this.$vs.loading.close();
      })
    },
    onGridReady() {
      if (this.$store.state.windowWidth <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }
      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },

    reportSpam: function () {
      this.popupActive = false;

    },
    deletePost: function (item) {
      this.selectedItem = item;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Xóa tin tức`,
        text: `Bạn có chắc chắn xóa tin tức`,
        accept: this.deleteRecord,
        acceptText: "Xác nhận",
        cancelText: "Huỷ"
      })
    },

    deleteRecord: function () {
      this.$vs.loading()
      this.$processor.post('/search/delete-data', {id: this.selectedItem.id}).then(response => {
        this.$vs.loading.close();
        this.popupActive = false;
        this.loadData();
        return this.$vs.notify({
          text: 'Xóa thành công',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        });
      }).catch(() => {
        this.$vs.loading.close();
        this.loadData();
        return this.$vs.notify({
          text: 'Xóa thất bại',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
    },
    getValueCheckbox: function () {
      let value = this.optionalsTopics.filter(item => item.checked).map(el => el.value);
      this.valueCheckbox = value;
    },
    onChangePage: function (event) {
      const page = String(event);
      this.pageNumbers = page - 1
      this.loadData();
    },
    openDialog: function (item) {
      this.popupActive = true;
      this.formData = {...this.fromData, ...item};
    },
    changeStar: function () {
      this.bookmark = false;
      this.star = true;
    },
    changeBookmark: function () {
      this.bookmark = true;
      this.star = false;
    },
    getValueRadio: function (value) {
      switch (value) {
        case 'SmileIcon':
          return this.valueRadio = 0;
      }
    },
    hideFilter: function () {
      this.filter = false;
    },
    showFilter: function () {
      this.filter = true;
    },
    //Date-range-picker
    formatDate: function (val) {
      return moment(val).format("DD/MM/YYYY");

    },
    dateFormat: function (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
  },
  async created() {
    this.loadDomain()
  },
  props: {
    config: {type: Object, default: () => ({})}
  }
}
</script>
<style scoped>
.marginLeft {
  width: 7% !important;
}

.mxh {
  width: 9% !important;

}

.down-width {
  width: 1% !important;
}

.vx-row {
  padding-bottom: 10px;
}

.post {
  font-size: 16px;
}

.fromTo {
  font-size: 13px;
  margin-right: 5%;
}

.titlePost {
  font-size: 13px;
  margin-left: 5px;
}

.like {
  font-size: 13px;
  color: #ccc;
}

.cartPost {
  width: 60% !important;
}

.dropDownBorder {
  border-top: 1px solid #ccc;
  margin-top: 10px;
}

.borderAndMarginBottom {
  border-bottom: 1px solid rgb(238, 234, 234);
  margin-bottom: 5px;
}

.marginRight {
  margin-left: 30%;
}

.iconGridLayout {
  padding-bottom: -5px;
}

.facebook-name {
  font-size: 25px;
}

.facebook-icon {
  background-color: #3B5998;
  color: white;
  margin-right: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border-radius: 70%;
}

.vs-popup {
  width: 50%;
}

.margin-dropdown {
  margin-left: 5% !important
}

.con-vs-dropdown--menu {
  z-index: 420000;
}

.vertical-icon {
  vertical-align: middle
}

.link-post {
  float: right;
  margin-top: 10px
}

.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.comment {
  margin-left: 1px;
}

.radio-margin-bottom-border {
  border-top: 1px solid #ccc;
  margin: 0px 0px 5px 0px;
  text-align: center;
  padding-top: 5px;
}

.image-post {
  max-width: 100%;
  margin-top: 10%;
  max-height: 100%;
}

.checkbox-min {
  min-width: 150px;
}

.top-right {
  position: absolute;
  top: 5px;
  right: 5px;
}

.reportrange-text {
  height: auto;
}

.vx-navbar-dropdown {
  width: 170px;
}

.fade-leave-active {
  transition: opacity 0.1s
}

.highlight {
  background-color: yellow;
}

.holamundo {
  z-index: 10000;
}
</style>
<style>

#list-article .vx-card__body {
  padding: 0.5rem !important;
}
</style>

<style lang="scss">
#full-article {
  .vs-popup {
    width: 50% !important;
  }

  .full-content {
    img {
      width: 100%;
      height: auto;
    }
  }

  //p {
  //  align-items: start;
  //}
}
</style>
